import React from 'react';

// Material UI
import { Autocomplete, Chip, TextField } from '@mui/material';
import { styled } from '@mui/system';

import { getColourFromString } from '../../../../utils/ColourNameGenerator';

const MyChip = styled(Chip)(({ colour }) => ({
  border: `1px solid ${colour.border}`,
  backgroundColor: colour.bg,
  boxSizing: 'border-box',
  borderRadius: '4px',
  marginRight: '6px',
}));

function ListInput({ pH, values, setValues, updateValueInValues }) {
  const value = values?.[pH?.key]?.value || [];

  const handleArray = s => {
    if (typeof s === 'string' || s instanceof String) {
      // We know it's a string
      if (s.length >= 2 && s[0] === '[' && s[s.length - 1] === ']') {
        // We know it's a list
        let eles = s.trim().slice(1, s.length - 1);
        return eles.split(',');
      } else return [];
    }
    return s;
  };

  return (
    <Autocomplete
      size="small"
      multiple
      options={[]}
      value={handleArray(value)}
      freeSolo
      clearOnBlur
      fullWidth
      variant="standard"
      /**
            Adding this to allow for duplicates.
            Also the form front end is using autocomplete from a different version
            of mui which has the allow Duplicates flag.
            */
      isOptionEqualToValue={(option, value) => false}
      renderInput={params => (
        <TextField {...params} variant="outlined" placeholder={'Enter list items'} multiline />
      )}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((option, index) => (
          <MyChip {...getTagProps({ index })} label={option} colour={getColourFromString(option)} />
        ));
      }}
      onBlur={e => {
        // Handle case where user types and clicks away without pressing Enter
        if (e.target.value && e.target.value.trim() !== '') {
          const trimmedValue = e.target.value.trim();

          if (!value.includes(trimmedValue)) {
            updateValueInValues(pH.key, [...value, trimmedValue]);
          }
        }
      }}
      onChange={(e, value, reason) => {
        if (reason === 'clear') {
          updateValueInValues(pH.key, []);
        } else if (reason === 'removeOption' || reason === 'createOption') {
          updateValueInValues(pH.key, value);
        }
      }}
    />
  );
}

export default ListInput;
